document.addEventListener("DOMContentLoaded", () => {
  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hasAttribute("disabled"));
  }

  function trapFocus(element) {
    const modal = element;
    const focusableElements = getFocusableElements(modal);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];

    modal.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      }
    });

    // Initially focus the first focusable element
    firstFocusableElement?.focus();
  }

  // Usage:
  document
    .querySelectorAll('[role="dialog"][aria-modal="true"]')
    .forEach((dialog) => {
      trapFocus(dialog);
    });

  // each page should have one h1
  const mainContent = document.getElementById("mainContent");
  if (mainContent) {
    const firstSection = mainContent.querySelector(".shopify-section");
    if (firstSection) {
      const h2 = firstSection.querySelector(
        'h2:not([class*="card-title h4"]):not(#bloggy--article h2)'
      );
      if (h2) {
        h2.setAttribute("aria-level", "1");
      }
    }
  }

  if (window.location.pathname === "/blogs/news/nfl-players-and-vaping") {
    const articleHeading = document.querySelector(
      "#bloggy--article h2.text--1636212959945"
    );
    if (articleHeading) {
      articleHeading.setAttribute("role", "paragraph");
    }
  }

  const reviewInterval = setInterval(() => {
    const reviewElements = document.querySelectorAll(
      ".kl_reviews__review__content"
    );
    if (reviewElements.length > 0) {
      reviewElements.forEach((content) => {
        content.setAttribute("role", "blockquote");
      });
      clearInterval(reviewInterval);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(reviewInterval);
  }, 10000);

  const pages = document.querySelectorAll(".loadmore .page");
  if (pages.length > 0) {
    const parentDiv = pages[0].parentElement;
    parentDiv.setAttribute("role", "list");
    pages.forEach((page) => {
      page.setAttribute("role", "listitem");
    });
  }

  // Toggle aria-expanded on menu dropdown caret click
  document.querySelectorAll("#mobmenu .dropdown-caret").forEach((caret) => {
    caret.addEventListener("click", function () {
      const isExpanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", !isExpanded);
    });
  });

  // Instafeed close button
  const instafeedInterval = setInterval(() => {
    const instafeedLightbox = document.querySelector(".instafeed-lightbox");
    if (instafeedLightbox) {
      document.querySelectorAll(".instafeed-close-button").forEach((button) => {
        button.setAttribute("role", "button");
        button.setAttribute("aria-label", "close");
      });
      document.querySelectorAll(".instafeed-new-arrow").forEach((button) => {
        button.setAttribute("role", "button");
      });
      clearInterval(instafeedInterval);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(instafeedInterval);
  }, 5000);

  document.querySelectorAll(".closex").forEach((closex) => {
    const button = closex.querySelector("button");
    const detailsMenu = closex.querySelector("details-menu");

    const toggleMenu = () => {
      if (closex.hasAttribute("open")) {
        closex.removeAttribute("open");
        detailsMenu?.setAttribute("aria-hidden", "true");
        detailsMenu.querySelectorAll("a").forEach((link) => {
          link.setAttribute("tabindex", "-1");
        });
      } else {
        closex.setAttribute("open", "");
        detailsMenu?.setAttribute("aria-hidden", "false");
        detailsMenu.querySelectorAll("a").forEach((link) => {
          link.setAttribute("tabindex", "0");
        });
      }
      button?.setAttribute("aria-expanded", closex.hasAttribute("open"));
    };

    if (button) {
      button.addEventListener("click", toggleMenu);
    }

    if (detailsMenu) {
      // Find the parent li and its next/previous sibling's link
      const parentLi = closex.closest("li");
      const nextSiblingLink = parentLi?.nextElementSibling?.querySelector("a");
      const prevSiblingLink =
        parentLi?.previousElementSibling?.querySelector("a");

      const handleFocusIn = function () {
        if (closex && detailsMenu) {
          closex.removeAttribute("open");
          detailsMenu?.setAttribute("aria-hidden", "true");
          button?.setAttribute("aria-expanded", "false");
          detailsMenu.querySelectorAll("a").forEach((link) => {
            link.setAttribute("tabindex", "-1");
          });
        }
      };

      // Add ESC key handler
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && closex.hasAttribute("open")) {
          handleFocusIn();
        }
      });

      if (nextSiblingLink) {
        nextSiblingLink.addEventListener("focusin", handleFocusIn);
      }

      if (prevSiblingLink) {
        prevSiblingLink.addEventListener("focusin", handleFocusIn);
      }
    }
  });

  document.querySelectorAll(".palyPauseBtn").forEach((button) => {
    button.addEventListener("click", function () {
      this.classList.toggle("paused");
    });
  });

  const swiperNotifications = document.querySelectorAll(".swiper-notification");
  if (swiperNotifications.length > 0) {
    swiperNotifications.forEach((notification) => {
      notification.setAttribute("aria-live", "polite");
    });
  }

  const instafeedItemsInterval = setInterval(() => {
    const instafeedItems = document.querySelectorAll(
      ".instafeed-new-layout-item"
    );
    if (instafeedItems.length > 0) {
      instafeedItems.forEach((item) => {
        const img = item.querySelector(".instafeed-lazy-image");
        const container = item.querySelector(
          ".instafeed-new-layout-item-container"
        );
        if (img && container && img.alt) {
          container.setAttribute("aria-label", `${img.alt} - opens in a popup`);
        }
      });
      clearInterval(instafeedItemsInterval);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(instafeedItemsInterval);
  }, 5000);

  // Check each bullet-marquee for redundant links
  document.querySelectorAll("bullet-marquee").forEach((marquee) => {
    const links = marquee.querySelectorAll(".projectile a");
    if (links.length > 0) {
      const firstLink = links[0];
      const firstHref = firstLink.getAttribute("href");
      const allSameLink = Array.from(links).every(
        (link) =>
          link.getAttribute("href") === firstHref &&
          link.textContent === firstLink.textContent
      );

      if (allSameLink) {
        const wrapper = document.createElement("a");
        wrapper.href = firstHref;
        wrapper.textContent = "";
        wrapper.setAttribute("aria-label", firstLink.textContent);

        // Convert links to text nodes
        links.forEach((link) => {
          link.parentNode.replaceChild(
            document.createTextNode(link.textContent),
            link
          );
        });

        // Place the marquee inside the wrapper
        const parent = marquee.parentElement;
        parent.replaceChild(wrapper, marquee);
        wrapper.appendChild(marquee);
      }
    }
  });

  const filterButtonsInterval = setInterval(() => {
    const filterButtons = document.querySelectorAll(
      ".alr-wh-comp-filter-buttons-write-review"
    );
    if (filterButtons.length > 0) {
      filterButtons.forEach((element) => {
        element.setAttribute("role", "button");
        element.setAttribute("tabindex", "0");
        element.addEventListener("keypress", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            element.click();
          }
        });
      });
      clearInterval(filterButtonsInterval);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(filterButtonsInterval);
  }, 5000);
});
